import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {};

type AnalyticsEvent = Record<string, unknown>;

const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {
    push(_state, _action: PayloadAction<AnalyticsEvent>) {
      /* do nothing */
    },
    requestConfig() {
      /* do nothing */
    },
  },
});

export const analytics = analyticsSlice.actions;
export default analyticsSlice.reducer;
